/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Tasks_IntroInputs */

const en_pc_online_tasks_intro = /** @type {(inputs: Pc_Online_Tasks_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every step below works in the window above. Click inside the app first so it receives your keyboard shortcuts, and use Ctrl where a Mac uses ⌘.`)
};

const zh_pc_online_tasks_intro = /** @type {(inputs: Pc_Online_Tasks_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下面每一步都可以在上方窗口中完成。请先点击应用内部，让它接收键盘快捷键；在 Windows 和 Linux 上用 Ctrl 代替 Mac 的 ⌘。`)
};

/**
* | output |
* | --- |
* | "Every step below works in the window above. Click inside the app first so it receives your keyboard shortcuts, and use Ctrl where a Mac uses ⌘." |
*
* @param {Pc_Online_Tasks_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_tasks_intro = /** @type {((inputs?: Pc_Online_Tasks_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Tasks_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_tasks_intro(inputs)
	return zh_pc_online_tasks_intro(inputs)
});
export { pc_online_tasks_intro as "pc.online.tasks_intro" }